// removed by extract-text-webpack-plugin
module.exports = {"template_container":"template_container__b_uZt","template_wrapper":"template_wrapper__28azZ","no_data_img":"no_data_img__F84x4","no_data_text":"no_data_text__2se8Q"};


//////////////////
// WEBPACK FOOTER
// ./components/no-data-template/style.scss
// module id = +6d5
// module chunks = 17